import PropTypes from 'prop-types'
import { useEffect } from 'react'
import Preview from 'features/creative/preview/Preview'
import LandingUrl from 'features/creative/add/common/LandingUrl'
import TextInput from 'components/form/TextInput'
import SelectBox from 'components/form/SelectBox'
import { useDispatch, useSelector } from 'react-redux'
import {
  rangeTypes,
  reset,
  setDescription,
  setIndividualChecked,
  setMobileUrl,
  setPcUrl,
  setPrice,
  setRange,
  validatePriceTableItem,
} from 'features/creative/add/asset/priceTableSlice'
import ErrorText from 'components/form/ErrorText'
import { removeNumber } from 'utils'
import useChannelLandingUrlPolicy from 'features/creative/add/common/useChannalLandingUrlPolicy'
import Button from 'components/form/Button'
import { inactiveAsset } from 'features/creative/add/build/buildCreativeSlice'

const PriceTable = ({ disabled, errors, imported }) => {
  const dispatch = useDispatch()
  const { priceTables } = useSelector(state => state.creative.assets.priceTable)

  useEffect(
    () => () => {
      dispatch(reset())
    },
    [dispatch]
  )

  const satisfied = index => validatePriceTableItem(priceTables[index])

  return (
    <div className="cont_material">
      <div className="group_material">
        <div className="box_material">
          <strong className="subtit_subject2">
            텍스트형 &gt; 가격테이블
            <Button
              size="small"
              disabled={disabled}
              onClick={() => {
                dispatch(inactiveAsset('priceTable'))
              }}>
              삭제
            </Button>
          </strong>
          <PriceTableItem
            index={0}
            errors={errors}
            disabled={disabled}
            required
            imported={imported}
          />
          <PriceTableItem
            index={1}
            errors={errors}
            disabled={disabled || !satisfied(0)}
            imported={imported}
          />
          <PriceTableItem
            index={2}
            errors={errors}
            disabled={disabled || !satisfied(1)}
            imported={imported}
          />
        </div>
        <Preview type="PRICE_TABLE" data={{ priceTables }} />
      </div>
    </div>
  )
}

const PriceTableItem = ({ index, required, disabled, errors, imported }) => {
  const dispatch = useDispatch()
  const { priceTables } = useSelector(state => state.creative.assets.priceTable)
  const {
    text,
    landingUrl: { individual, mobileUrl, pcUrl },
    price,
    range,
  } = priceTables[index]
  const error = errors?.prices[index]

  useChannelLandingUrlPolicy(
    v => setIndividualChecked({ index, checked: v }),
    disabled,
    imported
  )

  const onChangeIndividual = checked => {
    dispatch(setIndividualChecked({ index, checked }))
  }
  const onChangeMobileUrl = url => {
    dispatch(setMobileUrl({ index, url }))
  }
  const onChangePcUrl = url => {
    dispatch(setPcUrl({ index, url }))
  }
  const onChangeDescription = v => {
    dispatch(setDescription({ index, text: v }))
  }
  const onChangePrice = v => {
    dispatch(setPrice({ index, price: removeNumber(v) }))
  }
  const onChangeRange = v => {
    dispatch(setRange({ index, range: v }))
  }

  return (
    <div className="inner_material">
      <div className="material_item">
        <div className="tit_itemwrap">
          <strong className="tit_item">
            내용{index + 1}
            {required && <span className="fc_warn">*</span>}
          </strong>
        </div>
        <div className="desc_item">
          <TextInput
            value={text}
            onValueChange={onChangeDescription}
            placeholder="내용을 입력하세요"
            maxLength={9}
            trim
            disabled={disabled}
            error={error?.text}
          />
          <ErrorText error={error?.text} />
        </div>
      </div>
      <div className="material_item">
        <div className="tit_itemwrap">
          <strong className="tit_item">
            가격{index + 1}
            {required && <span className="fc_warn">*</span>}
          </strong>
        </div>
        <div className="desc_item">
          <div className="single_row">
            <TextInput
              className="box_inptxt box_inpwon "
              value={price}
              onValueChange={onChangePrice}
              placeholder="가격을 입력하세요"
              disabled={disabled}
              maxLength={9}
              error={error?.price}
            />
            <SelectBox
              className="opt_won"
              value={range}
              onValueChange={onChangeRange}
              disabled={disabled}
              error={error?.price}>
              {rangeTypes.map(type => (
                <SelectBox.Item key={type.id} value={type.id}>
                  {type.name}
                </SelectBox.Item>
              ))}
            </SelectBox>
          </div>
          <ErrorText error={error?.price} />
        </div>
      </div>
      <LandingUrl
        title={`랜딩 URL${index + 1}`}
        individual={individual}
        mobileUrl={mobileUrl}
        pcUrl={pcUrl}
        onChangeIndividual={onChangeIndividual}
        onChangeMobileUrl={onChangeMobileUrl}
        onChangePcUrl={onChangePcUrl}
        disabled={disabled}
        errors={{ mobileUrl: error?.mobileUrl, pcUrl: error?.pcUrl }}
      />
    </div>
  )
}

export default PriceTable

PriceTableItem.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number.isRequired,
  required: PropTypes.bool,
  errors: PropTypes.object,
  imported: PropTypes.bool,
}

PriceTable.propTypes = {
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    price: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    mobileUrl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    pcUrl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  }),
  imported: PropTypes.bool,
}
